import React from "react";
import Headline from "../components/shared/Headline";
import ContactAgentsForm from "../components/shared/ContactAgentsForm";
import AgentsApi from "../../api-services/agents-api.service";
import { Button, Card, Col, Modal, notification, Row } from "antd";
import { Agent } from "../../interfaces/agent.interface";
import { mdiMapMarker, mdiPhoneInTalkOutline, mdiWhatsapp, mdiEmailOutline } from "@mdi/js";
import Icon from "@mdi/react";

const { Meta } = Card;

const bannerPath = '/iceholidays-assets/images/contact_agents.png';
const breadcrumbs = [
  { title: 'Home' },
  { title: 'Contact Agents' }
] 

class ContactAgentsPage extends React.Component {
  agentsApi = new AgentsApi;

  state = {
    loading: true,
    allAgents: [],
    agents: [],
    states: [],
    cities: [],
    setIsModalOpen: false,
    agentData: { name: "", image: "", address: "", phone: "", whatsapp: "", email: "", city: "", state: "" },
  }


  componentDidMount() {
    this.agentsApi.getAgents()
      .then((agentsData:Agent[]) => {
        const states = agentsData.filter(a => a.state != null).map(a => a.state);
        const cities = agentsData.filter(a => a.city != null).map(a => a.city);
        this.setState({agents: agentsData, allAgents: agentsData, loadingAgents:false, states, cities});
      })
    .finally(()=>this.setState({loading: false}))
      .catch(error => {
        notification.error({ message: 'An error occured while loading agents.'});
      });
  }

  showModal(agentData){
    this.setState({setIsModalOpen: true, agentData: agentData});
  };

  closeModal(){
    this.setState({setIsModalOpen: false});
  };


  filterCities = (searchStr) => {
    const allAgents:Agent[] = this.state.allAgents;

    if(searchStr == undefined){
      this.resetAgents();
      return;
    }
    const agents:Agent[] = allAgents.filter(a => a.state == searchStr);
    const results = agents.map(a => a.city);
    this.setState({cities: results});
  }


  filterStates= (searchStr) => {
    const allAgents:Agent[] = this.state.allAgents;

    if(searchStr == undefined){
      this.resetAgents();
      return;
    }

    const agents:Agent[] = allAgents.filter(a => a.city == searchStr);
    const results = agents.map(a => a.state);
    this.setState({states: results});
  }

  resetAgents(){
    const allAgents:Agent[] = this.state.allAgents;
    const states = allAgents.filter(a => a.state != null).map(a => a.state);
    const cities = allAgents.filter(a => a.city != null).map(a => a.city);
    this.setState({states, cities});
  }

  findAgents = (formValues) => {
    const allAgents:Agent[] = this.state.allAgents;
    const agents = allAgents.filter(a => 
      (formValues.state == undefined || a.state === formValues.state) && 
      (formValues.city == undefined || a.city === formValues.city));
    this.setState({agents, showAgentsResults: true})
  }
  

  render(){
    const {agents, states, cities, agentData} = this.state;
    return (
      <div id="contact-agents-page">
        <Headline bannerImage={bannerPath} breadcrumbs={breadcrumbs} title="CONTACT AGENTS"/>

        <div id="contact-agents-page_body">
          <div id="find-agents">
            <div id="find-agents_header"><span>Get Your City</span></div>
            <div id="find-agents_form">
              <ContactAgentsForm 
                states={states} 
                cities={cities} 
                findAgents={this.findAgents} 
                filterCities={this.filterCities}
                filterStates={this.filterStates}/>
            </div>
          </div>

          <div id="agents-list">
            <Row gutter={[20, 20]}>
              {
                agents.map((agent:Agent) => (
                  <Col xs={24} sm={24} md={12} lg={6}>
                    <Card
                      hoverable
                      cover={<img alt={agent.name} src={agent.image} />}
                    >
                      <Meta title={agent.name} description={
                        <>
                          <div className="agent-details">
                            <Row gutter={[20, 20]} align="middle">
                              <Col span={24}>
                                <Icon path={mdiMapMarker} size="15px" />
                                <span>{agent.address}</span>
                              </Col>
                              <Col span={24}>
                                <Icon path={mdiPhoneInTalkOutline} size="15px" />
                                <span>{agent.phone}</span>
                              </Col>
                              <Col span={24}>
                                <Icon path={mdiWhatsapp} size="15px" />
                                <span>{agent.whatsapp}</span>
                              </Col>
                              <Col span={24}>
                                <Icon path={mdiEmailOutline} size="15px" />
                                <span>{agent.email}</span>
                              </Col>
                            </Row>
                          </div>
                          <Button color="primary" variant="outlined" className="more-info-button" 
                            onClick={()=>this.showModal(agent)}>
                              More info
                          </Button>
                        </>
                      } />
                    </Card>
                  </Col>
                ))
              }
            </Row>
          </div>

          <Modal title={
            <>
              <img src={agentData?.image}/>
              <span> {agentData.name} </span>
            </>
          } open={this.state.setIsModalOpen} onCancel={()=>this.closeModal()} footer={null} width={350} centered className="agent-full-details">
            <Row gutter={[10,10]}>
              <Col span={12}> <label>Agent Name</label> </Col>
              <Col span={12}> <span> {agentData.name} </span></Col>
              <Col span={12}> <label>State</label> </Col>
              <Col span={12}> <span> {agentData.state} </span></Col>
              <Col span={12}> <label>Address</label> </Col>
              <Col span={12}> <span> {agentData.address} </span></Col>
              <Col span={12}> <label>Tel</label> </Col>
              <Col span={12}> <span> {agentData.phone} </span></Col>
              <Col span={12}> <label>Email</label> </Col>
              <Col span={12}> <span> {agentData.email} </span></Col>
            </Row>
            {/* google maps */}
          </Modal>
        </div>
      </div>
    )
  }
}

export default ContactAgentsPage;